export enum ReeferMake {
    Unknown,
    Carrier,
    IBOX
}
